"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Speed = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Speed = function Speed(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.853 7.835L9.187 9.733A1.196 1.196 0 016.8 9.6a1.2 1.2 0 011.684-1.097l2.97-1.357c.442-.202.794.409.399.69zm1.69 4.965H10.8V12a.4.4 0 00-.4-.4H5.6a.4.4 0 00-.4.4v.8H2.458a6.348 6.348 0 01-.827-2.6H2.2a.6.6 0 000-1.2h-.57a6.372 6.372 0 011.443-3.479l.402.402a.597.597 0 00.848 0 .6.6 0 000-.848l-.402-.402A6.369 6.369 0 017.4 3.23v.57a.6.6 0 001.2 0v-.57a6.369 6.369 0 013.479 1.442l-.402.402a.6.6 0 10.849.848l.402-.402A6.371 6.371 0 0114.37 9h-.57a.6.6 0 000 1.2h.569a6.353 6.353 0 01-.826 2.6zM8 1.6c-4.411 0-8 3.589-8 8a7.96 7.96 0 001.35 4.445.8.8 0 00.664.355h11.972a.8.8 0 00.665-.355A7.96 7.96 0 0016 9.6c0-4.411-3.589-8-8-8z",
    fill: "currentColor"
  }));
};

exports.Speed = Speed;
var _default = Speed;
exports.default = _default;